export const appKey = '322986529' // app-key

export const maxCodeTime = 60 // 验证码倒计时

export const MODULE_CONFIG = {
  INDEX: 1, // 首页
  WELFARE: 3, // 公益
  VIDEO: 4, // 视频课程
  NEWS: 5, // 新闻动态

  US: 2, // 关于我们
  MECHANISM: 50, // 机构
  BYLAWS: 51, // 章程
  ARCHITECTURE: 52, // 组织架构
  HONOR: 53, // 资质荣誉
  BUILDING: 57, // 党建学习
  VOLUNTEER: 58, // 志愿者
  CONTACT: 59, // 联系我们

  INFO: 6, // 信息公开
  // SJ_REPORT: 7, // 审计报告
  // ND_REPORT: 8, // 年度报告
  // GL_REPORT: 9  // 管理制度
}

// TODO:
export const moduleConfig = [{
  id: MODULE_CONFIG.INDEX,
  router: 'index'
}, {
  id: MODULE_CONFIG.WELFARE,
  router: 'publicWelfare'
}, {
  id: MODULE_CONFIG.VIDEO,
  router: 'video'
}, {
  id: MODULE_CONFIG.NEWS,
  router: 'news'
}, {
  id: MODULE_CONFIG.INFO,
  router: 'info'
}, {
  id: MODULE_CONFIG.US,
  router: 'about'
}]

export const fileUploadUrl = 'http://cloud.changanfoundation.com/api/v1/obs/files-upload'
// export const fileUploadUrl = 'http://incloud.qa.iotwisdom.cn/api/v1/obs/files-upload'